<template>
    <v-card outlined tile>
        <v-alert dense v-if="edit_sample" color="orange">Editing</v-alert>
        <v-alert dense color="info" class="white--text" v-if="manifestSet && currentManifestSample !== manifest_samples.length">
          <v-row class="ma-0">
            <v-col class="pa-0" cols="9">
              Manifest Loaded! Currently on sample {{this.currentManifestSample+1}}/{{manifest_samples.length}}
            </v-col>
            <v-col class="pa-0">
              <v-btn @click="backwards" class="mr-3" small icon outlined dark>
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn @click="forward" class="mr-3" small icon outlined dark>
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
              <v-menu>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon small outlined dark><v-icon>mdi-menu-open</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(manifest, index) in manifest_samples" :key="index" @click="currentManifestSample = index">
                    <v-list-item-content>
                      <v-list-item-title>{{manifest.qa}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-alert>
        <v-alert v-else-if="manifestSet && currentManifestSample === manifest_samples.length" color="info" class="white--text" dense>Done! You can add any additional samples if needed through this form.</v-alert>
        <v-card-text>
            <v-form ref="form" @submit.prevent>
                <v-autocomplete
                        label="Select Customer"
                        v-model="form.customer_id"
                        :items="names"
                        item-text="name"
                        item-value="customer_id"
                        filled
                >
                </v-autocomplete>
                <div class="pa-0 pb-1">
                  <Notes v-if="form.customer_id"
                         :customer_id="form.customer_id"
                         :table_headers="[
                          {text: 'Note', value:'note'}
                       ]"
                         dense
                         :filter="(note) => note.note_type.desc === 'Sample'"
                         flat hide_header
                         no_pagination
                         hide_no_data
                         hide_table_header>
                  </Notes>
                </div>
                <template v-if="imperatives">
                    <v-chip class="error" v-for="imperative in imperatives">{{imperative.imperative_type.desc}}</v-chip>
                </template>
                <v-text-field
                        label="Manifest ID"
                        v-model="form.manifest_id"
                >
                </v-text-field>
                <v-text-field
                        label="Sample Name"
                        v-model="form.name"
                        :persistent-hint="manifestSet"
                        :hint="manifestSet ? manifest_samples[currentManifestSample].manifest_item.inventory_name : ''"
                >
                </v-text-field>
                  <v-checkbox v-model="useInventoryName" label="Use inventory name" @change="swapSampleName"></v-checkbox>
                <v-autocomplete
                        label="Sample Product Type"
                        v-model="form.sample_cert_type"
                        :items="sampleCertTypes"
                        item-text="name"
                        :persistent-hint="manifestSet"
                        :hint="manifestSet ? 'Traceability type: '+ form.legal_type : ''"
                        return-object
                        filled
                >
                </v-autocomplete>
                <SampleTestSelection ref="test_selection" :imperatives="imperatives" :sample_cert_type="form.sample_cert_type"></SampleTestSelection>
                <v-text-field
                        label="Qa"
                        v-model="form.qa"
                >
                </v-text-field>
                <v-text-field
                        label="Lot"
                        v-model="form.lot"
                >
                </v-text-field>
                <v-text-field
                    label="Unit Weight"
                    v-model="form.serving_weight"
                >
                </v-text-field>
                <v-radio-group v-model="form.is_rnd" row>
                    <v-radio
                            label="QA"
                            :value="false"
                    >
                    </v-radio>
                    <v-radio
                            label="RND"
                            :value="true"
                    >
                    </v-radio>
                </v-radio-group>
                <v-btn @click="form.notes.push({sample_note_type_uuid: null, note: null})" color="success">Add a note</v-btn>
                <template v-for="note in form.notes">
                  <v-autocomplete label="Note Type" v-model="note.sample_note_type_uuid" :items="$store.$db().model('sampleNoteTypes').all()" item-text="name" item-value="uuid"></v-autocomplete>
                  <v-textarea label="Note" v-model="note.note"></v-textarea>
                </template>
            </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn color="error" @click="clearForm" tile outlined>Clear form</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="edit_sample" color="orange" @click="doneEditing" tile outlined>Done editing sample</v-btn>
            <v-btn v-else color="success" @click="addSample" tile outlined>Add sample <v-icon>mdi-arrow-right</v-icon></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "SampleForm",
        components:{
            SampleTestSelection: () => import("./SampleTestSelection"),
            Notes: () => import("@/views/DirectoryV2/components/Notes")
        },
        props:{
            edit_sample:{
                required: false,
            },
            manifest_samples:{
                required: false
            },
        },
        data: () => ({
          currentManifestSample: 0,
          manifestSet: false,
          useInventoryName: false,
            form:{
                customer_id: null,
                is_editing: false,
                manifest_id: null,
                order_id: null,
                sample_cert_type: null,
                sample_cert_type_uuid: null,
                name: null,
                sample_type_uuid: null,
                legal_type: null,
                qa: null,
                lot: null,
                is_rnd: false,
                serving_weight: null,
                harvest_date: null,
                unit_uuid: null,
                created_by: null,
                updated_by: null,
                notes: [],
            },
        }),
        watch:{
            edit_sample(v){
                if(v){
                    this.form = v;
                }
            },
            currentManifestSample(v){
              if(v === this.manifest_samples.length) return;
              this.manifest_samples[v].customer_id = this.form.customer_id;
              this.form = this.manifest_samples[v]
            },
            manifest_samples(v){
              if(v && !this.manifestSet){
                this.form = this.manifest_samples[this.currentManifestSample];
                this.manifestSet = true;
              }else{
                this.manifestSet = false;
              }
            }
        },
        mounted(){
          if(this.manifest_samples){
            this.form = this.manifest_samples[0];
            this.manifestSet = true;
          }
        },
        computed:{
            unit(){
                return this.$store.$db().model('units').query().where("name", "g").first();
            },
            names(){
              return this.$store.$db().model('names').all();
            },
            sampleCertTypes(){
                return this.$store.$db().model('sampleCertTypes').all();
            },
            imperatives(){
               if(this.form.customer_id){
                   return this.$store.$db().model('imperatives')
                       .query()
                       .where('customer_id', this.form.customer_id)
                       .with('imperative_type')
                       .get();
               }else{
                   return false;
               }
            },
            fullForm(){
                let unit = this.$store.$db().model('units').query().where('name', 'g').first()
                return {
                    ...this.form,
                    sample_cert_type_uuid: this.form.sample_cert_type ? this.form.sample_cert_type.uuid : null,
                    unit_uuid: unit ? unit.uuid : null,
                    tests: this.$refs.test_selection ? this.$refs.test_selection.tests : [],
                    created_by: this.$store.getters.id,
                    updated_by: this.$store.getters.id,
                }
            }
        },
        methods:{
            swapSampleName(){
                if(this.useInventoryName){
                  this.form.name = this.manifest_samples[this.currentManifestSample].manifest_item.inventory_name;
                }else{
                  this.form.name = this.manifest_samples[this.currentManifestSample].manifest_item.strain_name;
                }
            },
            addSample(){
                if(this.$refs.form.validate()){
                    console.log(this.fullForm);
                    this.$emit("add_sample", {...this.fullForm});
                    if(!this.manifestSet || (this.manifestSet && (this.currentManifestSample+1 === this.manifest_samples.length) || this.currentManifestSample === this.manifest_samples.length)) {
                      this.clearForm();
                      if(this.manifest_samples) this.currentManifestSample = this.manifest_samples.length;
                    }else{
                      this.currentManifestSample = this.currentManifestSample + 1;
                      this.useInventoryName = false;
                    }
                }
            },
            forward(){
              if(this.currentManifestSample+1 < this.manifest_samples.length){
                this.currentManifestSample = this.currentManifestSample + 1;
              }else{
                this.$store.dispatch("showError", "There are no more samples in this manifest to move forward to.")
              }
            },
            backwards(){
              if(this.currentManifestSample > 0){
                this.currentManifestSample = this.currentManifestSample - 1;
              }else{
                this.$store.dispatch("showError", "There are no more samples in this manifest to move back to.")
              }
            },
            clearForm(){
                this.form = {
                    ...this.form,
                    qa: null,
                    lot: null,
                }
            },
            doneEditing(){
                this.$emit('done_editing');
                this.clearForm()
            }
        }
    }
</script>

<style scoped>

</style>
